import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-updown",
  "use": "arrow-updown-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"arrow-updown\">\n  <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M8.435 25.604l.27.306 20.4 22.835c.69.773 1.725 1.255 2.88 1.255 1.155 0 2.19-.496 2.88-1.255l20.385-22.79.345-.38c.255-.365.405-.803.405-1.27C56 23.036 54.89 22 53.51 22H10.49C9.11 22 8 23.036 8 24.305c0 .482.165.934.435 1.299z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol